import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { DriverDailyMetricAdminDto } from '@/backend/market'
import { DriverDailyMetricEntity } from '../../domain/entities/DriverDailyMetricEntity'

export class DriverDailyMetricModel extends DriverDailyMetricEntity {
  constructor(data: DriverDailyMetricAdminDto) {
    super()
    mapEntityProperties(this, data)
  }
}
